<template>
    <div class="wrapper">
        <div class="pt-ended">
            <h3 class="pt-ended__title">
                {{ $t('user.user_playtime_ended_title') }}
            </h3>

            <p class="pt-ended__subtitle">
                {{ $t('user.user_playtime_ended_subtitle', { tariffName: tariffLabel }) }}
            </p>

            <ul class="pt-ended__hints">
                <li>
                    <tariff-restriction-notice>
                        <template #before>{{ $t('user.user_playtime_ended_hint_before') }}</template>
                        {{ $t('user.user_playtime_ended_hint_link') }}
                        <template #after>{{ $t('user.user_playtime_ended_hint_after') }}</template>
                    </tariff-restriction-notice>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import TariffsApi from '@/api/tariffs/tariffs';
    import TariffRestrictionNotice from '@/components/tariffs/TariffRestrictionNotice';
    import { extractTariffsFromResponse } from '@/utils/tariffHelper';

    export default {
        components: {
            TariffRestrictionNotice,
        },
        data() {
            return {
                neededTariff: null,
            };
        },
        mounted() {
            this.getTariffs();
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            tariffName() {
                if (this.neededTariff) {
                    return this.$i18n.t(`billing.billing_tariff_${this.neededTariff.name}`);
                }
                return '';
            },
            // «Name» for the subtitle placeholder, or empty when tariff is unknown
            tariffLabel() {
                return this.tariffName ? ` «${this.tariffName}»` : '';
            },
        },
        methods: {
            async getTariffs() {
                try {
                    const userTariffId = this.user.schools[0].tariffId;

                    const response = await TariffsApi.list();
                    const tariffs = extractTariffsFromResponse(response);

                    this.neededTariff = tariffs.find(item => Number(item.id) === userTariffId);
                } catch (error) {
                    console.error('Failed to fetch tariffs:', error);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .wrapper {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .pt-ended {
        display: grid;
        gap: 12px;
    }

    .pt-ended__icon {
        font-size: 24px;
        line-height: 1;
    }

    .pt-ended__title {
        margin: 0;
        font-weight: 700;
        font-size: 18px;
    }

    .pt-ended__subtitle {
        margin: 0;
        color: #444;
    }

    .pt-ended__reset {
        margin: 0;
        color: #333;
    }

    .pt-ended__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 4px;
    }

    .pt-ended__btn {
        appearance: none;
        border: 1px solid $x-color-gray-5;
        background: transparent;
        border-radius: $border-radius-8;
        padding: 8px 12px;
        cursor: pointer;
        font-weight: 600;

        &--primary {
            background: #111;
            color: #fff;
            border-color: #111;
        }

        &--ghost {
            background: transparent;
        }
    }

    .pt-ended__hints {
        margin: 4px 0 0;
        padding-left: 18px;
        color: #555;

        li {
            margin: 2px 0;
        }
    }
</style>
